import React from 'react'
import { Field, InjectedFormProps, reduxForm } from 'redux-form'
import { Button, Col, Container, Form as BootstrapForm, Row } from 'react-bootstrap'
import * as ReactBootstrap from 'react-bootstrap'
import { renderers } from '../../components'

/**
 * Form data shape
 */
export interface EditPenaltyFormData {
  cost: string
}

/**
 * Component Props – none in this case besides `InjectedFormProps`
 */
type EditPenaltyFormProps = {}

/**
 * EditPenaltyForm Component
 */
const EditPenaltyForm: React.FC<InjectedFormProps<EditPenaltyFormData, EditPenaltyFormProps>> = ({
  handleSubmit,
}) => {
  return (
    <Container>
      <h3 className="my-3">Update Penalty Amounts</h3>
      <BootstrapForm onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col md={12}>
            <ReactBootstrap.Col xs={12} md={12}>
              <Field
                label="Cost"
                name="cost"
                component={renderers.renderField}
                type="text"
              />
            </ReactBootstrap.Col>
          </Col>
        </Row>

        <Row>
          <Col className="text-end">
            <Button type="submit" variant="dark">
              Submit
            </Button>
          </Col>
        </Row>
      </BootstrapForm>
    </Container>
  )
}

/**
 * Redux-connected version
 */
export default reduxForm<EditPenaltyFormData, EditPenaltyFormProps>({
  form: 'editLoanerPenaltyForm',
})(EditPenaltyForm)
